import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-checking">
        <div className="font-display text-2xl animate-pulse">Caricamento...</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/accedi" replace />;
  }
  return children;
}
